var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navbar',{attrs:{"windowPositions":_vm.windowPositions}}),_c('Slider'),_c('About'),_c('Feature'),_c('Work'),_c('Screenshots'),_c('Team'),_c('Package'),_c('Testimonial'),_c('FAQ'),_c('Blog'),_c('Download'),_c('Footer'),_c('Subscribe'),_c('Copyright'),_c('div',{attrs:{"id":"fb-root"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }